"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var usersTemplateSent_1 = __importDefault(require("../mock/usersTemplateSent"));
var templateSentSummary_1 = __importDefault(require("../mock/templateSentSummary"));
var emailServiceUrl = process.env.CB_EMAIL_SERVICE_SERVER_URL;
var emailServiceAPI = {
    usersTemplateSent: function (token, templateType, templateUuid) {
        return rest_1.default.get({
            mockFunc: function () { return (0, usersTemplateSent_1.default)(); },
            url: "".concat(emailServiceUrl, "/users-template-sent?templateType=").concat(templateType, "&templateUuid=").concat(templateUuid),
            token: token,
        });
    },
    templateSentSummary: function (token, templateType) {
        return rest_1.default.get({
            mockFunc: function () { return (0, templateSentSummary_1.default)(); },
            url: "".concat(emailServiceUrl, "/template-sent-summary?templateType=").concat(templateType),
            token: token,
        });
    },
};
exports.default = emailServiceAPI;
